import { useState } from 'react';
import { getFormDefaultValue, getTableHeaders } from '../../utils/forms/FormDataModel';
import AbstractLanding from '../Entity/AbstractLanding';
import AbstractTabs, { TabActiosEventType, TabActiosProps } from '../Entity/AbstractTabs';
import { PARTNER_ORDERS } from '../../constants/EntityName';
import { partnerOrdersFormData } from '../../datamodels/PartnerOrders';
import GenericAccordian from '../../components/GenericAccordian/GenericAccordian';
import AbstractForm from '../Entity/AbstractForm';
import { ContentItem, OnAddArguments } from '../../utils/forms/FormInterface';

const PartnerOrders = () => {
  const [activeKey, setActiveKey] = useState<string>('0');
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [content, setContent] = useState<any>([]);
  const [tabCount, setTabCount] = useState<number | undefined>(undefined);
  const [tabCountText, setTabCountText] = useState<string>('Items');

  const tableHeaders: any = getTableHeaders(partnerOrdersFormData);
  const headerName = 'Agent Orders';

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  const updateFormVisibility = (
    action: TabActiosProps,
    targetKey?: string | TabActiosEventType
  ) => {
    if (action === 'remove') {
      onTabClick('0'); // Switch back to list view on close
      setContent((content: any) => content.filter((item: any) => String(item.key) !== targetKey));
    }
  };

  const closeTab = (key: string, shouldRefresh: boolean) => {
    setContent((content: any) => content.filter((item: any) => item.key !== key));
    setActiveKey('0');
    shouldRefresh && setRefreshData(prev => !prev);
  };

  const onSuccessful = (id?: string) => {
    onTabClick('0');
    setRefreshData(prev => !prev);
  };

  const onAdd = (argument1: OnAddArguments) => {
    // Check if tab already exists
    const checkArr = content.filter((item: ContentItem) => item.key === argument1.id);
    if (checkArr.length) {
      setActiveKey(String(argument1.id));
      return;
    }

    const newObj = {
      key: argument1.id,
      tabTitle: argument1.groupCode
        ? typeof argument1.groupCode === 'string'
          ? argument1.groupCode.slice(-5)
          : String(argument1.groupCode).slice(-5)
        : argument1.id,
      content: (
        <GenericAccordian key={content.length}>
          <AbstractForm
            entityId={argument1.id}
            isCreateMode={false}
            headerName={headerName}
            entityName={PARTNER_ORDERS}
            formTemplate={partnerOrdersFormData}
            formDefaultPayload={getFormDefaultValue(partnerOrdersFormData)}
            onSuccessfulUpdate={onSuccessful}
            formHeader=""
            showDeleteDraft={false} // Orders probably shouldn't be deleted this way
            closeTab={closeTab}
            hiddenButtons={{ update: true }}
            // additionalEntityName={additionalEntityName} // Add if needed
          />
        </GenericAccordian>
      ),
    };

    setContent((prev: any) => [...prev, newObj]);
    argument1.id && setActiveKey(String(argument1.id));
  };

  const onAddNew = (argument1?: OnAddArguments) => {
    if (argument1) {
      onAdd(argument1);
    }
    // No "Create New" flow for now as per requirement
  };

  const handleTotalCountChange = (count: number | undefined, countText: string) => {
    setTabCount(count);
    setTabCountText(countText);
  };

  return (
    <AbstractTabs
      activeKey={activeKey}
      entityName={headerName}
      updateFormVisibility={updateFormVisibility}
      onTabClick={onTabClick}
      showFormComponent={false}
      content={content}
      tabCount={tabCount}
      tabCountText={tabCountText}
    >
      <AbstractLanding
        headerName={headerName}
        entityName={PARTNER_ORDERS}
        tableHeaders={tableHeaders}
        addName="Order"
        refreshData={refreshData}
        onAdd={onAddNew}
        disableAdd={true} // Creates are disabled, but row clicks trigger onAdd
        showFilter={true}
        showDownload={false}
        reportRedirectPath="/documitra-reports"
        filterListData
        onTotalCountChange={handleTotalCountChange}
      />
    </AbstractTabs>
  );
};

export default PartnerOrders;
